export default "/images/b360c7d4ae75ecaa5f237731168b2730.avif";